import Marionette from "backbone.marionette";
import Radio from "backbone.radio";
import TabCollection from "../../../../../collections/tabs";
import GenericModel from "../../../../../models/generic";
import MatchPointChooserMetaModel from "../../../../../models/chart-reviews/drg-matchpoint-chooser-meta";

import ClaimMatches from "./claim-matches";
import ParamSettings from "./param-settings";
import ParamTypeSettings from "./param-type-settings";

// common templates and environment
import templates from "../../../../../utils/templates";
import environment from "../../../../../common/environment";

const channel = Radio.channel("global");

const DEFAULTS = {
  className: "row",
  template: templates.find("layout", "generic_tabbed_view"),
};

// tab configuration
const VIEW_CONFIG = [
  {
    id: "matchpoint-claim-matches",
    label: "Claim Matches",
    active: true,
    view: ClaimMatches,
  },
  {
    id: "matchpoint-param-settings",
    label: "Parameter Settings",
    active: false,
    view: ParamSettings,
  },
  {
    id: "matchpoint-param-type-settings",
    label: "Parameter Type Settings",
    active: false,
    view: ParamTypeSettings,
  },
];

class View extends Marionette.LayoutView {
  constructor(options = {}) {
    _.defaults(options, DEFAULTS);
    super(options);
  }

  events() {
    return {
      "shown.bs.tab": "_onTabShown",
    };
  }

  childEvents() {
    return {
      "modal:close": "_hide",
    };
  }

  initialize() {
    // create tab collection
    this.collection = new TabCollection(VIEW_CONFIG);

    // copy original model to UI Model be used by children views
    this.uiModel = this.model || null;

    // reset passed in model to be used by layout view
    this.model = new GenericModel({
      tabs: VIEW_CONFIG,
    });

    this.setupData = {};
  }

  onBeforeRender() {
    // add regions to layout
    this.collection.each((tab) => {
      this.addRegion(tab.getId(), `#tab-${tab.id}`);
    });

    // retrieve setup data, and fetch DRG details on success
    this._getSetupData();
  }

  _getSetupData() {
    const endpointConfig = {
      chartId: this.uiModel.get("chartReviewId"),
      drgId: this.uiModel.get("id"),
    };

    // fetch chooser metadata here in order to determine the paramSetSid and
    // paramTypeSetSid needed by the child tabs.
    $.when(
      $.ajax(
        environment.getEndpoint(
          "chart-reviews:drg-edit:matchpoint-chooser:meta",
          endpointConfig
        )
      ).then(
        // on success
        (meta) => {
          // create meta model and add to setup data
          this.setupData.chooserMetadata = new MatchPointChooserMetaModel(meta);

          // finally, inject views
          this._renderRegions();
        },

        // on failure
        (jqXHR) => {
          // close this modal
          this._hide();

          let message =
            "We were unable to retrieve all the data necessary for MatchPoint selection. Please try again later.";

          switch (jqXHR.status) {
            case 409:
              message =
                "We are unable to continue as more than one MatchPoint was found for this Diag. Please notify your administrator.";
              break;
          }

          // show error
          channel.trigger("status:show", {
            autoDismiss: false,
            type: "danger",
            message,
          });
        }
      )
    );
  }

  _renderRegions() {
    // add views to regions
    this.collection.each((tab) => {
      // extract view and view model from config
      const View = tab.getView();
      const ViewModel = tab.getViewModel();
      const data = Object.assign({}, tab.getData(), this.setupData);

      // does config define a view?
      if (View) {
        // does config define a view model?
        let view;
        if (ViewModel) {
          // configure view with view model
          view = new View({
            model: new ViewModel(),
            data,
          });
        } else {
          // configure view with passed in model
          view = new View({
            model: this.uiModel,
            data,
          });
        }

        // render the view
        this[tab.getId()].show(view);
      }
    });
  }

  _onTabShown(e) {
    channel.trigger("tab-activated", $(e.target).attr("aria-controls"));
  }

  _hide() {
    // notify parent layout of this change
    this.triggerMethod("modal:close");
  }
}

export { View as default };
